export {
  type GraphemeCompoundGrapheme,
  graphemeCompoundGraphemeTable,
} from "#grapheme-compound-grapheme-table";
